<template>
    <b-form-group :label="label" :description="description" :invalid-feedback="error" :state="state">
        <form-input-group :left-icon="leftIcon" :class="[floatingLabel ? 'floating-label' : '']">
            <b-form-file
                v-on="listeners"
                v-bind="attrs"
                ref="fileInput"
                :value="value"
                :state="state"
                :multiple="multiple"
                :file-name-formatter="formatNames"
                @input="input"
            ></b-form-file>
            <span :if="floatingLabel" :style="{ left: leftIcon ? '3.1rem' : '' }">{{ floatingLabel }}</span>
        </form-input-group>
    </b-form-group>
</template>

<script>
import { formFieldMixin } from '../../../mixins/form-field-mixin';
import FormInputGroup from '../form-input-group/form-input-group.vue';

export default {
    name: 'FormFile',
    mixins: [formFieldMixin],
    components: {
        FormInputGroup,
    },
    props: {
        value: {
            type: [Array, File],
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        formatNames: {
            type: Function,
            default: null,
        },
        leftIcon: [Object, Array, String],
        floatingLabel: [String, Number],
    },
};
</script>

<style lang="scss" scoped>
@import '../../../variables.scss';

:deep(.custom-file-input) {
    cursor: pointer;
}

:deep(.custom-file-label, .custom-file-label:after) {
    border-top-right-radius: 0.25rem !important;
    border-bottom-right-radius: 0.25rem !important;
}

:deep(.floating-label div > label.custom-file-label) {
    line-height: 1.6;
    padding-bottom: 0.1rem;
    padding-top: 1rem;
    z-index: inherit;
    height: $floating-label-input-height-active;
}

:deep(.floating-label div > label.custom-file-label:after) {
    line-height: 1.9rem;
    z-index: inherit;
    height: $floating-label-input-height-active-file;
    margin-bottom: 5px;
}

.floating-label span {
    position: absolute;
    user-select: none;
    pointer-events: none;
    margin: 0;
    top: 0.2rem;
    left: 0.8rem;
    z-index: 99;
    font-size: 0.8rem;
    line-height: 1.1;
    color: $floating-label-color-active;
    font-weight: $floating-label-font-weight;
}
:deep(.form-file-text) {
    text-wrap: auto;
}
</style>
